import React from "react";

const SocialIcons = ({ Icons }) => {
  return (
    <div className="text-teal-500">
      {Icons.map((icon) => (
        <a href={icon.link} key={icon.name} target="_blank" rel="noopener noreferrer">
          <span
            className="p-2 cursor-pointer inline-flex items-center rounded-full bg-gray-900 mx-1.5 text-xl hover:text-gray-100 hover:bg-teal-500 duration-300"
            style={{ width: "32px", height: "32px" }}
          >
            <img
            className="rounded-full"
              src={icon.src}
              alt={icon.name}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </span>
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
